import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/image/learningportal.svg";
import Error from "../../components/ui/Error";
import { useRegisterMutation } from "../../features/auth/authApi";

export default function StudentRegistration() {
  const nameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [register, { data, isLoading, isSuccess, error: responseError }] =
    useRegisterMutation();

  const handleRegistration = (e) => {
    e.preventDefault();
    console.log("here");
    if (passwordRef.current.value !== confirmPasswordRef.current.value) {
      setError("Password did not match");
      return;
    }
    console.log("submitted");
    register({
      email: emailRef?.current?.value,
      password: passwordRef?.current?.value,
      role: "student",
      name: nameRef.current.value,
    });
  };

  useEffect(() => {
    if (isSuccess && data?.user) {
      //login success redirect to courseplayer
      navigate("/coursePlayer");
    }
    if (responseError?.data) {
      setError(responseError.data);
    }
    document.title = "Student registration";
  }, [responseError, setError, isSuccess, data, navigate]);

  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" alt="" src={logo} />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleRegistration}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="name" className="sr-only">
                Name
              </label>
              <input
                ref={nameRef}
                onChange={() => setError("")}
                id="name"
                name="name"
                type="name"
                autoComplete="name"
                required
                className="login-input rounded-t-md"
                placeholder="Student Name"
              />
            </div>
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                ref={emailRef}
                onChange={() => setError("")}
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="login-input "
                placeholder="Email address"
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                ref={passwordRef}
                onChange={() => setError("")}
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="login-input"
                placeholder="Password"
              />
            </div>
            <div>
              <label htmlFor="confirm-password" className="sr-only">
                Confirm Password
              </label>
              <input
                ref={confirmPasswordRef}
                onChange={() => setError("")}
                id="confirm-password"
                name="confirm-password"
                type="password"
                autoComplete="confirm-password"
                required
                className="login-input rounded-b-md"
                placeholder="Confirm Password"
              />
            </div>
          </div>

          <div>
            <button
              disabled={isLoading}
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
            >
              Create Account
            </button>
          </div>
          <div className="text-center">
            Already have account?{" "}
            <Link className="text-violet-600 " to={"/"}>
              Login
            </Link>
          </div>
          {error !== "" && <Error message={error} />}
        </form>
      </div>
    </section>
  );
}
